import { render, staticRenderFns } from "./rewardModal.vue?vue&type=template&id=37dd8a86&scoped=true"
import script from "./rewardModal.vue?vue&type=script&lang=js"
export * from "./rewardModal.vue?vue&type=script&lang=js"
import style0 from "./rewardModal.vue?vue&type=style&index=0&id=37dd8a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dd8a86",
  null
  
)

export default component.exports